import {IMetricParameterSet} from "./PA.Metrics.IF";
import {IHaveExecutionBounds} from "../PA.Core/PA.Core.IF.Aspects";
import * as _ from "lodash";
import {MetricParameters, MetricsParameterSet} from "./PAMetrics";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Finished_Product} from "../PA.Core/PAdbSchema";
import {WB_CustomerRow, WB_FinishedProductRow} from "../PA.Core/PAdbSchemaRows";
import * as AsyncLock from 'async-lock'
import {PASearch} from "../PA.Core/PASearch";



export class PAMetricUtils {

  static dbContext: PAdbContext = undefined

  static dctCnsAdjPrdLock: any = new AsyncLock()
  static dctProductsByCnsPG: {[id:number]: number[]} = {}

    static createMetricParameterSet(eb: IHaveExecutionBounds,
                                    arrPlanningCustomers?: WB_CustomerRow[],
                                    arrSourceCustomers?: WB_CustomerRow[],
                                    arrProducts?: WB_FinishedProductRow[]
                                    ) : IMetricParameterSet
    {
        const self = this;

        if(_.isEmpty(eb)){ return undefined }
        let mps: MetricsParameterSet = new MetricsParameterSet();
        let mpe: MetricParameters = new MetricParameters();
        mpe.MetricParameterId = "Export";
        mpe.InStoreStartDt = eb.Execution_InStore_Aligned.StartDt;
        mpe.InStoreEndDt = eb.Execution_InStore_Aligned.EndDt;
        mpe.ShipmentStartDt = eb.Execution_Shipment_Aligned.StartDt;
        mpe.ShipmentEndDt = eb.Execution_Shipment_Aligned.EndDt;
        mpe.bCalculateIntersection = false;
        if(_.isEmpty(arrPlanningCustomers))
            mpe.PlanningCustomers = _.map(eb.Execution_PlanningCustomers, (item) => {return item.cif.WB_CUST_ID});
        else
            mpe.PlanningCustomers = _.map(arrPlanningCustomers, (item) => {return item.cif.WB_CUST_ID});

        if(_.isEmpty(arrSourceCustomers))
            mpe.SourceCustomers = _.map(eb.Execution_SourceCustomers, (item)=> {return item.cif.WB_CUST_ID});
        else
            mpe.SourceCustomers = _.map(arrSourceCustomers, (item)=> {return item.cif.WB_CUST_ID});

        if(_.isEmpty(arrProducts))
            mpe.FinishedProducts = _.map(eb.Execution_FinishedProducts, (item) => {return item.cif.WB_PROD_ID});
        else
            mpe.FinishedProducts = _.map(arrProducts, (item) => {return item.cif.WB_PROD_ID});

        mps[mpe.MetricParameterId] = mpe;

        return mps;

    }

  static staticMetricParameterSet_preProcess(aMPS: IMetricParameterSet): Promise<void> {

    return new Promise<void>((resolve, error) => {

      PAMetricUtils.staticMetricParameterSet_preProcessConsumptionAdjustmentPGs(aMPS)
        .then(()=> {
            return PAMetricUtils.staticMetricParameterSet_preProcessConsumerProducts(aMPS)
        })
        .then(()=> {
            resolve()
        })
        .catch((err) => {
            error(err)
        })

    })

  }

  static staticMetricParameterSet_preProcessConsumerProducts(aMPS: IMetricParameterSet): Promise<void> {

        return new Promise<void>((resolve, error) => {
            if(PAMetricUtils.dbContext == undefined){
              PAMetricUtils.dbContext = new PAdbContext()
            }

            if(_.isEmpty(aMPS)){
                resolve();
                return
            }

            // 1. Translate any Products that are UPCs to UPCs.
            let dctFP: {[id:number]: number} = {};
            _.forEach(aMPS, (value, key) => {
                _.forEach(value.FinishedProducts, (aWBId) => {
                    if((aWBId > 0) && (!(aWBId in dctFP))){
                      dctFP[aWBId] = aWBId
                    }
                })
            });

            if(_.isEmpty(dctFP)) {
                resolve();
                return
            }

            // -- create dictionary of product by key
            PAMetricUtils.dbContext.findUsingCache(esWB_Finished_Product, _.keys(dctFP))
                .then((arrFinishedProducts: WB_FinishedProductRow[]) => {
                    //
                    let dctFinishedProduct = _.keyBy(arrFinishedProducts, (fp: WB_FinishedProductRow) => {
                        return fp.cif.WB_PROD_ID
                    });

                    _.forEach(aMPS, (value, key) => {

                        let FinishedProductsNew: number[] = [];
                        let ConsumerProductUPCsNew: string[] = value.ConsumerProductUPCs;
                        let dctConsumerProductUPC = _.keyBy(value.ConsumerProductUPCs, (upc) => { return upc});
                        _.forEach(value.FinishedProducts, (aWBId) => {

                            //
                            if(aWBId in dctFinishedProduct){
                                let fp = dctFinishedProduct[aWBId];
                                if(fp.cif.PRODUCT_SET_ID == "UPC"){
                                    let sUPC = fp.cif.CONSUMER_PRODUCT_UPC;
                                    if(!(sUPC in dctConsumerProductUPC)){
                                        dctConsumerProductUPC[sUPC] = sUPC;
                                        ConsumerProductUPCsNew.push(sUPC);
                                    }
                                } else {
                                    FinishedProductsNew.push(aWBId);
                                }
                            } else {
                                FinishedProductsNew.push(aWBId);
                            }

                            value.FinishedProducts = FinishedProductsNew;
                            value.ConsumerProductUPCs = ConsumerProductUPCsNew;

                        })

                    });

                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })
    }

  static staticMetricParameterSet_preProcessConsumptionAdjustmentPGs(aMPS: IMetricParameterSet): Promise<void> {

    return new Promise<void>((resolve, error) => {

      PAMetricUtils.dctCnsAdjPrdLock.acquire("Global" , (done:any) => {

        let dctCnsPGs: {[id:number]: number} = {}

        // For Each Metric Parameters
        _.forEach(aMPS, (mp, mpKey) => {
          _.forEach(mp.ConsumptionAdjustmentsPGs, (aWB_CNSPG_ID) => {
            if(!(aWB_CNSPG_ID in dctCnsPGs)){
              dctCnsPGs[aWB_CNSPG_ID] = aWB_CNSPG_ID
            }
          })
        })

        let dctCnsPGsToAdd: {[id:number]: number} = {}
        _.forEach(dctCnsPGs, (value,key) => {
          if(!(value in PAMetricUtils.dctProductsByCnsPG)){
            dctCnsPGsToAdd[value] = value
          }
        })

        if(_.isEmpty(dctCnsPGsToAdd)){
          done()
          return
        }

        let arrCnsPGIDs  = _.values(dctCnsPGsToAdd)
        PASearch.find("WB_CNSPRD",{WB_CNSPG_ID: {inq: arrCnsPGIDs}},
          {WB_CNSPG_ID: {type: "number"}, WB_PROD_ID: {type: "number"}}, [],0,['WB_CNSPG_ID','WB_PROD_ID'])
          .then((results: any[]) => {
            let dct: {[id:number]: number[]} = {}
            _.forEach(results, (aRow) => {
              let aWB_CNSPG_ID = _.toNumber(aRow.WB_CNSPG_ID)
              let aWB_PROD_ID =  _.toNumber(aRow.WB_PROD_ID)
              if(aWB_CNSPG_ID in dct){
                dct[aWB_CNSPG_ID].push(aWB_PROD_ID)
              } else {
                dct[aWB_CNSPG_ID] = [aWB_PROD_ID]
              }
            })

            //
            _.forEach(dct, (value, key) => {
              PAMetricUtils.dctProductsByCnsPG[_.toNumber(key)] = value
            })

            _.forEach(arrCnsPGIDs, (idx) => {
              if(!(idx in PAMetricUtils.dctProductsByCnsPG)){
                PAMetricUtils.dctProductsByCnsPG[idx] = []
              }
            })

            // Now convert the rest
            _.forEach(aMPS, (mp, mpKey) => {
              _.forEach(mp.ConsumptionAdjustmentsPGs, (aWB_CNSPG_ID) => {
                if(aWB_CNSPG_ID in PAMetricUtils.dctProductsByCnsPG){
                  mp.FinishedProducts.push.apply(mp.FinishedProducts, PAMetricUtils.dctProductsByCnsPG[aWB_CNSPG_ID])
                }
              })

              if((mp.ConsumptionAdjustmentsPGs.length > 0) && (mp.FinishedProducts.length == 0)){
                mp.FinishedProducts.push(-1)
              }

            })

            done()

          })
          .catch((err) => {
            done()
          })

      }).then((ignore: any) => {
        resolve()
      }).catch((err:any) => {
        error(err)
      })

    })
  }


}